import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import OptionsSelectionViewModal from '../../optionsSelectionView/OptionsSelectionViewModal';
import './GridsModal.css';

const GridsModal = ({
  show,
  onHide,
  onGridSelect,
  windowURL,
  isSelectedItem,
  typeName,
  addOption,
  addTransum,
  setGlassToSearch,
  setStringToSearch,
  setStringToSearchSide,
  isTransum,
  setIsTransum,
  title = "Options"
}) => {
  const { t } = useTranslation();
  const [selectedOption, setSelectedOption] = useState(null);
  const [showSubModal, setShowSubModal] = useState(false);

  if (!show && !showSubModal) {
    return null;
  }

  // Determine if showing grids or decorative glass
  const gridOrGlass = windowURL && windowURL.includes("Door") && !windowURL.includes("NoGlassSidelightFull");

  const options = [
    {
      id: 'grids',
      name: t('grids-grids', 'Grids'),
      thumbnail: '/thumbnails/Window_Casement_Double_Grid1.png',
      description: 'Add grid patterns to windows',
      type: 'window',
      eventKey: windowURL,
      show: !gridOrGlass && isSelectedItem && windowURL && !windowURL.includes("Contemporary") && !windowURL.includes("Fixed") && !windowURL.includes("Door")
    },
    {
      id: 'decorativeGlass',
      name: t('grids-decorativeGlasses', 'Decorative Glasses'),
      thumbnail: '/thumbnails/Vitrail_Novatech_Bolero_22x48_Thumbnail.png',
      description: 'Add decorative glass to doors',
      type: 'door',
      eventKey: windowURL,
      show: gridOrGlass && isSelectedItem && !windowURL.includes("Sidelight3A") && !windowURL.includes("GarageDoor") && !windowURL.includes("SidelightFlat") && !windowURL.includes("FlatWithSidelightFull")
    }
  ];

  const visibleOptions = options.filter(opt => opt.show);

  const handleOptionClick = (option) => {
    // Open the sub-modal with options
    setShowSubModal(true);
  };
  
  const handleSubModalHide = () => {
    setShowSubModal(false);
  };
  
  const handleFinalSelection = () => {
    setShowSubModal(false);
    onHide(); // Close GridsModal too
  };

  const portalContainer = document.body;

  if (!portalContainer) {
    return null;
  }

  const modalContent = (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      className="grids-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title || t('grids-options', 'Options')}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {visibleOptions.length === 0 ? (
          <div className="no-options-message">
            <p>{t('grids-noOptions', 'No options available for this item')}</p>
          </div>
        ) : (
          <div className="grids-grid">
            {visibleOptions.map((option) => (
              <div
                key={option.id}
                className="grid-option-item"
                onClick={() => handleOptionClick(option)}
                title={option.description}
              >
                <div className="grid-option-thumbnail">
                  <img src={option.thumbnail} alt={option.name} />
                </div>
                <div className="grid-option-name">{option.name}</div>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('common.cancel', 'Cancel')}
        </Button>
      </Modal.Footer>
    </Modal>
  );

  // Use React Portal to render modal in canvasContainer
  return (
    <>
      {ReactDOM.createPortal(modalContent, portalContainer)}
      {showSubModal && (
        <OptionsSelectionViewModal
          show={showSubModal}
          onHide={handleSubModalHide}
          onFinalClose={handleFinalSelection}
          isTransum={isTransum}
          setIsTransum={setIsTransum}
          addOption={addOption}
          addTransum={addTransum}
          windowURL={windowURL}
          typeName={typeName}
          setGlassToSearch={setGlassToSearch}
          setStringToSearch={setStringToSearch}
          setStringToSearchSide={setStringToSearchSide}
        />
      )}
    </>
  );
};

export default GridsModal;
